import { footerMessageFormatter } from '../../service/helpers';
import { ImageEntity } from '../../types';
import { QuizActionTypes, QuizValues, Step } from './types';

export interface QuizState {
  loading: boolean;
  currentStep: Step;
  answers: QuizValues;
  quizImages: {
    stepImages: ImageEntity[];
    optionImages: ImageEntity[];
  };
  footerText: string;
  prevStepSlug: string;
  nextStepSlug: string;
  lastStepSlug: string;
  currentNumber: number;
  totalNumber: number;
  currentQuestionNumber: number;
  shouldClearOnBack: boolean;
}

export const initialState: QuizState = {
  loading: false,
  currentStep: null,
  footerText: '',
  prevStepSlug: '/',
  quizImages: {
    stepImages: [],
    optionImages: [],
  },
  nextStepSlug: null,
  lastStepSlug: null,
  answers: {},
  currentNumber: 1,
  totalNumber: null,
  currentQuestionNumber: null,
  shouldClearOnBack: false,
};

export function quizReducer(state = initialState, action: QuizActionTypes): QuizState {
  switch (action.type) {
    case 'SET_FOOTER_MESSAGE':
      const text = footerMessageFormatter(action.payload);

      return {
        ...state,
        footerText: text,
      };
    case 'CLEAN_FOOTER_MESSAGE':
      return {
        ...state,
        footerText: '',
      };
    case 'LOAD_STEP_REQUESTED':
      return {
        ...state,
        loading: true,
      };
    case 'LOAD_STEP_FAILURE':
      return {
        ...state,
        loading: false,
        currentStep: null,
        nextStepSlug: null,
      };
    case 'LOAD_STEP_SUCCEEDED': {
      return {
        ...state,
        currentStep: action.payload.currentStep,
        prevStepSlug: action.payload.prevStepSlug,
        nextStepSlug: action.payload.nextStepSlug,
        lastStepSlug: action.payload.lastStepSlug,
        currentNumber: action.payload.currentNumber,
        totalNumber: action.payload.totalNumber,
        currentQuestionNumber: null,
      };
    }
    case 'COMPLETE_QUIZ': {
      return {
        ...state,
        prevStepSlug: state.currentStep.slug,
        currentStep: null,
        currentNumber: null,
      };
    }
    case 'SAVE_ANSWERS':
      return {
        ...state,
        answers: action.payload,
      };
    case 'TOGGLE_QUESTIONS': {
      return {
        ...state,
        currentQuestionNumber: action.payload,
        footerText: '',
        answers: state.currentStep.questions.reduce(
          (acc, question) => {
            delete acc[question.name];
            return acc;
          },
          { ...state.answers },
        ),
      };
    }
    case 'GOTO_PREVIOUS_STEP': {
      return {
        ...state,
        answers:
          state.shouldClearOnBack && state.currentStep
            ? Object.keys(state.answers).reduce((acc, key) => {
                if (!state.currentStep.questions.find((question) => question.name === key)) {
                  acc[key] = state.answers[key];
                }
                return acc;
              }, {})
            : { ...state.answers },
      };
    }
    case 'CLEAR_ANSWERS': {
      return {
        ...state,
        answers: {},
      };
    }
    case 'LOAD_QUIZ_IMAGES_SUCCEEDED': {
      return {
        ...state,
        quizImages: action.payload,
      };
    }
    default:
      return state;
  }
}
